import { render, staticRenderFns } from "./AttributeListCreateOrEdit.vue?vue&type=template&id=1684e691&scoped=true&"
import script from "./AttributeListCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./AttributeListCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./AttributeListCreateOrEdit.vue?vue&type=style&index=0&id=1684e691&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1684e691",
  null
  
)

export default component.exports